// src/pages/Orders.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "orders"));
        const orderList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOrders(orderList);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>📦 Your Orders</h2>

      {orders.length === 0 ? (
        <p>No orders yet!</p>
      ) : (
        orders.map((order) => (
          <div
            key={order.id}
            style={{
              width: "350px",
              margin: "15px auto",
              border: "1px solid #ccc",
              padding: "15px",
              borderRadius: "10px",
              textAlign: "left",
            }}
          >
            <p><b>Order ID:</b> {order.id}</p>
            <p><b>Date:</b> {order.createdAt?.toDate ? order.createdAt.toDate().toLocaleDateString() : "—"}</p>
            <p>
              <b>Product:</b> {order.name}
            </p>
            <p><b>Size:</b> {order.size}</p>
            <p><b>Price:</b> ₹{order.price}</p>
            <p><b>Status:</b> {order.status}</p>
          </div>
        ))
      )}
    </div>
  );
}

export default Orders;
